import { PaymentActionTypes } from "../../../enums";

const {
  PAYMENT_CANCELLED,
  PAYMENT_STARTED,
  PAYMENT_IN_REVIEW,
  PAYMENT_CREATED,
  PAYMENT_SOURCE_UPDATED,
} = PaymentActionTypes;

interface InitialState {
  status: any;
  reservationId: any;
}
const initialState: InitialState = {
  status: null,
  reservationId: null,
};

export function payment(state = initialState, action: any) {
  switch (action.type) {
    case PAYMENT_CANCELLED:
      return { ...state, reservationId: null, status: null, paymentSourceId: null };
    case PAYMENT_STARTED:
      return { ...state, status: PAYMENT_STARTED, reservationId: action?.reservationId };
    case PAYMENT_IN_REVIEW:
      return { ...state, status: PAYMENT_IN_REVIEW };
    case PAYMENT_CREATED:
      return { ...state, status: PAYMENT_CREATED };
    case PAYMENT_SOURCE_UPDATED:
      return { ...state, paymentSourceId: action.paymentSourceId };
    default:
      return state;
  }
}
